/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_DescriptionInputs */

const en_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extract burnt-in subtitles and on-screen text from video using optical character recognition.`)
};

const fr_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraire les sous-titres incrustés et le texte à l'écran d'une vidéo à l'aide de la reconnaissance optique de caractères.`)
};

const de_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrahieren Sie mithilfe von optischer Zeichenerkennung (OCR) eingebettete Untertitel und Bildschirmtexte aus Videos.`)
};

const it_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrai i sottotitoli incorporati e il testo visualizzato sullo schermo dai video utilizzando il riconoscimento ottico dei caratteri.`)
};

const ru_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлеките встроенные субтитлы и экранный текст из видео с помощью оптического распознавания символов.`)
};

const es_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrae subtítulos incrustados y texto en pantalla de vídeos mediante reconocimiento óptico de caracteres.`)
};

const zh_cn2_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用光学字符识别技术从视频中提取内嵌字幕和屏幕文字。`)
};

const ja_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`光学文字認識（OCR）を使用して、動画から焼き付けられた字幕や画面上のテキストを抽出します。`)
};

const hi_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑप्टिकल कैरेक्टर रिकग्निशन का उपयोग करके वीडियो से बर्न-इन सबटाइटल और ऑन-स्क्रीन टेक्स्ट निकालें।`)
};

const pt_pt2_ocr_description = /** @type {(inputs: Ocr_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraia legendas embutidas e textos na tela de vídeos usando reconhecimento óptico de caracteres.`)
};

/**
* | output |
* | --- |
* | "Extract burnt-in subtitles and on-screen text from video using optical character recognition." |
*
* @param {Ocr_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_description = /** @type {((inputs?: Ocr_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_description(inputs)
	if (locale === "de") return de_ocr_description(inputs)
	if (locale === "it") return it_ocr_description(inputs)
	if (locale === "ru") return ru_ocr_description(inputs)
	if (locale === "es") return es_ocr_description(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_description(inputs)
	if (locale === "ja") return ja_ocr_description(inputs)
	if (locale === "hi") return hi_ocr_description(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_description(inputs)
	return en_ocr_description(inputs)
});